import { useScanStats } from '@projects/pages/detail/hooks';
import { memo } from 'react';
import { Typography } from '@mui/material';
import { convertThreeViewportToMapbox } from '@core/logic';
import { useSelector } from 'react-redux';
import { viewer3dSelectors } from '@viewer3D/redux';
import { MIN_ZOOM_FOR_RENDERING } from '@scans/components/Scans/hooks';
import { trenchSelectors } from '@trenches/redux';
import { useGetPhotoListQuery } from '@core/redux/query';
import { useSnapshot } from 'valtio';
import { photosState } from '@photos/components/PhotosInViewport/state';

const ScanStatsBase = () => {
  const { total, loaded, hidden, loading } = useScanStats();
  const { showPhotos } = useSnapshot(photosState);
  const cameraViewport = useSelector(viewer3dSelectors.cameraViewport);
  const { zoom } = convertThreeViewportToMapbox(cameraViewport);
  const allTrenches = useSelector(trenchSelectors.selectAll);
  const projectId = useSelector(viewer3dSelectors.selectedProjectId) || '';
  const { isLoading, isFetching } = useGetPhotoListQuery({ projectId }, { skip: !showPhotos });

  if (allTrenches.length === 0) {
    return (
      <Typography variant="subtitle1" noWrap>
        Loading Trenches, please wait...
      </Typography>
    );
  }

  if (zoom && zoom < MIN_ZOOM_FOR_RENDERING) {
    return (
      <Typography variant="subtitle1" noWrap>
        No Scans visible, zoom in to see them
      </Typography>
    );
  }

  if (isLoading || isFetching) {
    return (
      <Typography variant="subtitle1" noWrap>
        Loading Photos, please wait...
      </Typography>
    );
  }

  const scanStats: string[] = [`${loaded} visible`];
  if (hidden > 0) scanStats.push(`${String(hidden)} hidden`);
  if (loading > 0) scanStats.push(`${loading} loading`);
  if (total > 0) scanStats.push(`${total} total`);

  return (
    <Typography variant="subtitle1" noWrap>
      Scans: {scanStats.join(' | ')}
    </Typography>
  );
};

export const ScanStats = memo(ScanStatsBase);
